import React from 'react'
import RadioGroup from '@cloudscape-design/components-themed/radio-group'

// https://cloudscape.design/components/radio-group
export function RadRadioGroup ({ ...rest }) {
  return (
    <RadioGroup {...rest} />
  )
}
